import { useCallback, useLayoutEffect, useState } from 'react';

const useDropdownSelection = ({ count, selectedIndex }) => {
    const clampIndex = useCallback((index) => {
        if (!Number.isFinite(index) || count <= 0) {
            return 0;
        }
        return Math.min(Math.max(0, index), count - 1);
    }, [count]);

    const [selected, setSelected] = useState(() => clampIndex(selectedIndex));

    useLayoutEffect(() => {
        setSelected((current) => {
            const safeCurrent = clampIndex(current);

            if (selectedIndex === undefined || selectedIndex === null) {
                return safeCurrent;
            }

            const next = clampIndex(selectedIndex);
            return current === next ? current : next;
        });
    }, [clampIndex, selectedIndex]);

    return [selected, setSelected];
};

export default useDropdownSelection;
